import classes from "./About.module.css";
import CommonTitle from "./CommonTitle";
import Layout from "./Layout";
import Image from './Image'
import xingdu from '../assets/xingdu.png';
import jian from '../assets/jian.png';

export default function About({id}) {
    return (
        <Layout id={id}>
            <CommonTitle title="关于我们"/>
            <div className={classes["about-content"]}>
                <div className={classes["about-code"]}>
                    <Image width={167} height={167} src={xingdu} alt=""/>
                    <Image width={167} height={167} src={jian} alt=""/>
                </div>
                <div className={classes["about-contact"]}>
                    <span>联系电话：010-52668287</span>
                    <span>官方邮箱：stararc@stararc.cn</span>
                    <span>公司官网：<a className={classes["about-concat__link"]}
                                      href="http://www.stararc.cn"
                                      target="_blank">www.stararc.cn</a>
                    </span>
                    <span>公司地址：北京市朝阳区朝阳路69号财满街财富中心1栋1单元1601室</span>
                </div>
            </div>
        </Layout>
    )
}
